export default {
  title: 'Delivery Address',
  buttons: {
    save: 'Save',
  },
};
